import React from 'react';

// The network-trust lifecycle as a compact horizontal stepper. A new plan
// climbs observed → calling → confirmed → building → established; "established"
// needs a phone confirmation plus N clean completed visits (mirrors the
// server's plan_stage gate). The trailing label shows live progress.
const STAGES = [
  { k: 'observed', label: 'Observed' },
  { k: 'calling', label: 'Calling' },
  { k: 'confirmed', label: 'Confirmed' },
  { k: 'building', label: 'Building' },
  { k: 'established', label: 'Established' },
];

export default function PlanStageStepper({ stage = 'observed', info = {} }) {
  const idx = Math.max(0, STAGES.findIndex((s) => s.k === stage));
  const cur = STAGES[idx];
  const established = stage === 'established';
  const target = info.target ?? 5;
  const visits = info.cleanVisits ?? 0;
  const showProgress = !established && (stage === 'confirmed' || stage === 'building');

  return (
    <div className="flex items-center gap-2" title={info.detail || ''}>
      <div className="flex items-center gap-1">
        {STAGES.map((s, i) => (
          <span
            key={s.k}
            className={`h-1.5 rounded-full transition-all ${
              i <= idx ? (established ? 'bg-emerald-500' : 'bg-brand-500') : 'bg-slate-200'
            } ${i === idx ? 'w-5' : 'w-2.5'}`}
          />
        ))}
      </div>
      <span className={`text-[11px] font-medium ${established ? 'text-emerald-700' : 'text-slate-600'}`}>
        {cur.label}
        {showProgress && <span className="text-slate-400"> · {visits}/{target} visits</span>}
      </span>
    </div>
  );
}
